var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconClients = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.109,
    height: 10.772,
    viewBox: "0 0 17.109 10.772",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    transform: "translate(-493.349 -856.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M503.425,859.057v-.909a2.094,2.094,0,0,0-4.188,0v.909a2.094,2.094,0,0,0,4.188,0Zm-3.637,0v-.909a1.543,1.543,0,0,1,3.086,0v.909a1.543,1.543,0,0,1-3.086,0Z",
    transform: "translate(0.576 0)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M498.531,866.37h6.753a.276.276,0,0,0,.276-.277h0v-.633h4.623a.275.275,0,0,0,.276-.276v-1.791a2.069,2.069,0,0,0-1.937-2.064.323.323,0,0,0-.284.158,1.267,1.267,0,0,1-1.782.178,1.285,1.285,0,0,1-.216-.227.274.274,0,0,0-.228-.112,2.064,2.064,0,0,0-1.016.3,2.316,2.316,0,0,0-1.618-.8.332.332,0,0,0-.284.165,1.485,1.485,0,0,1-2.345-.057.274.274,0,0,0-.228-.112,2.312,2.312,0,0,0-1.6.7c-.035.036-.068.072-.1.11a2.06,2.06,0,0,0-.941-.3.321.321,0,0,0-.284.158,1.268,1.268,0,0,1-1.782.178,1.284,1.284,0,0,1-.216-.227.276.276,0,0,0-.228-.112,2.069,2.069,0,0,0-2.016,2.067v1.791a.276.276,0,0,0,.277.276h4.63v.633A.276.276,0,0,0,498.531,866.37Zm7.362-4.483a1.819,1.819,0,0,0,2.567.162,1.884,1.884,0,0,0,.156-.156,1.517,1.517,0,0,1,1.29,1.5v1.515H505.56v-1.771a2.306,2.306,0,0,0-.255-1.056,1.491,1.491,0,0,1,.588-.194Zm-5.494-.51a2.039,2.039,0,0,0,2.875.21,1.987,1.987,0,0,0,.2-.2,1.775,1.775,0,0,1,1.53,1.754v2.68h-6.2v-2.68A1.781,1.781,0,0,1,500.4,861.377Zm-6.5,3.532v-1.515a1.527,1.527,0,0,1,1.346-1.506,1.819,1.819,0,0,0,2.566.162,1.874,1.874,0,0,0,.156-.156,1.521,1.521,0,0,1,.539.19,2.3,2.3,0,0,0-.253,1.054v1.771Z",
    transform: "translate(0 0.465)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M508.024,859.777v-.8a1.867,1.867,0,1,0-3.735,0v.8a1.867,1.867,0,0,0,3.735,0Zm-3.184,0v-.8a1.316,1.316,0,0,1,2.632,0h0v.8a1.316,1.316,0,0,1-2.632,0Z",
    transform: "translate(1.071 0.103)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M498.327,859.777v-.8a1.868,1.868,0,1,0-3.736,0v.8a1.868,1.868,0,0,0,3.736,0Zm-3.184,0v-.8a1.316,1.316,0,0,1,2.632,0h0v.8a1.316,1.316,0,0,1-2.632,0Z",
    transform: "translate(0.122 0.103)",
    fill: "#173a6d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconClients, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_clients.8ab0e093.svg";
export { ForwardRef as ReactComponent };